import { userClusterOptions, groupClusterOptions, policyClusterOptions, roleClusterOptions } from '../store/access-graph-options';
import recourceClusterSvgImage from '../../assets/images/clsuters/resource-cluster.svg';
export const searchNode = (network, searchedNodeText, allLevels) => {
  if (searchedNodeText.length) {
    let nodesObject = network.body.data.nodes._data;

    if (!searchedNodeText.includes(`Resource Cluster`)) {
      let nodeIds = Object.keys(nodesObject);
      let selectedNodeIds = nodeIds.filter(nodeId => {
        let searchText = searchedNodeText && searchedNodeText.length > 20 ? `${searchedNodeText.toUpperCase().substring(0, 20)}...` : searchedNodeText.toUpperCase();
        return nodesObject[nodeId].label && nodesObject[nodeId].label.toUpperCase().includes(searchText);
      });
      let selectedClusterIds = selectedNodeIds.map(selectedNodeId => {
        return network.body.data.nodes._data[selectedNodeId].clusterId;
      });
      selectedClusterIds.forEach(selectedClusterId => {
        if (network.isCluster(selectedClusterId) === true) {
          network.openCluster(selectedClusterId);
        }
      });
      network.clustering.updateClusteredNode(selectedNodeIds[0], {
        color: {
          border: '#FF8C00'
        },
        borderWidth: 20
      }); //To-do
      // const positions = network.getPositions(selectedNodeIds[0]);
      // network.focus(selectedNodeIds[0], {
      // offset: { x: 0, y: 0 },
      // scale: 1,
      // locked: false,
      // animation: {
      // duration: 150
      // }
      // });

      highLightEntirePath(network, nodesObject[selectedNodeIds[0]], allLevels);
    } else {
      let clusterNodes = [];
      Object.keys(nodesObject).forEach(nodeId => {
        if (searchedNodeText.includes(nodesObject[nodeId].clusterId)) {
          clusterNodes.push(nodesObject[nodeId]);
        }
      });

      if (clusterNodes.length > 1) {
        network.openCluster(clusterNodes[0].clusterId);
        clusterNodes.forEach(node => {
          network.clustering.updateClusteredNode(node.id, {
            color: {
              border: '#FF8C00'
            },
            borderWidth: 20
          });
        });
      }
    }
  }
};
export const clusterNodes = (network, params) => {
  if (params.nodes.length === 1) {
    if (network.isCluster(params.nodes[0]) === true) {
      network.openCluster(params.nodes[0]);
      return params.nodes[0];
    }
  }
};
export const declusterNodes = (network, params) => {
  if (params.nodes[0]) {
    var nodeClusterId = network.body.data.nodes._data[params.nodes[0]].clusterId;
    clusterBasedOnId(network, nodeClusterId);
    return nodeClusterId;
  }
};
export const clusterBasedOnId = (network, clusterId) => {
  if (clusterId !== 'userCluster' && clusterId !== 'groupCluster' && clusterId !== 'policyCluster' && clusterId !== 'roleCluster') {
    network.clustering.cluster({
      joinCondition: nodeOptions => {
        return nodeOptions.clusterId === clusterId;
      },
      clusterNodeProperties: {
        id: clusterId,
        borderWidth: 3,
        shape: 'circularImage',
        image: recourceClusterSvgImage,
        level: 5,
        label: clusterId,
        size: 100
      },
      clusterEdgeProperties: {
        label: ''
      }
    });
  }

  switch (clusterId) {
    case 'userCluster':
      network.clustering.cluster(userClusterOptions);
      break;

    case 'groupCluster':
      network.clustering.cluster(groupClusterOptions);
      break;

    case 'policyCluster':
      network.clustering.cluster(policyClusterOptions);
      break;

    case 'roleCluster':
      network.clustering.cluster(roleClusterOptions);
      break;

    default:
      return '';
  }
};
export const highLightEntirePath = (network, nodeData, allLevels) => {
  const allEdgeIds = getAllEdgeIds(network);
  allEdgeIds.forEach(edgeId => {
    network.clustering.updateEdge(edgeId, {
      color: '#808080',
      width: 2,
      font: {
        size: 0
      }
    });
  });

  if (nodeData.level === allLevels[allLevels.length - 1]) {
    network.getConnectedEdges(nodeData.id).forEach(pathEdge => {
      network.clustering.updateEdge(pathEdge, {
        color: '#1B3FEE',
        width: 10,
        font: {
          size: 50
        }
      });
    });
  }

  const parentEdges = [];
  const childEdges = [];
  let presentNodeIds = [nodeData.id];
  let presentNodeLevel = nodeData.level;
  let pathEdges = [];

  if (nodeData.level === 1) {
    pathEdges = [...new Set(getAllEdgeIds(network))];
  } else {
    for (let i = presentNodeLevel; i >= allLevels[0]; i--) {
      presentNodeIds.forEach(presentNodeId => {
        let presentParentEdges = network.getConnectedEdges(presentNodeId).filter(connectingEdge => {
          return connectingEdge.split('->')[1] === presentNodeId;
        });
        presentParentEdges.forEach(presentParentEdge => {
          parentEdges.push(presentParentEdge);
        });
        let presentParentNodes = presentParentEdges.map(parentEdge => {
          return parentEdge.split('->')[0];
        });
        presentNodeIds = presentParentNodes;
      });
    } // A -> B


    presentNodeIds = [nodeData.id];
    presentNodeLevel = nodeData.level;

    for (let i = presentNodeLevel; i <= allLevels[allLevels.length - 1]; i++) {
      presentNodeIds.forEach(presentNodeId => {
        let presentChildEdges = network.getConnectedEdges(presentNodeId).filter(connectingEdge => {
          return connectingEdge.split('->')[0] === presentNodeId;
        });
        presentChildEdges.forEach(presentChildEdge => {
          childEdges.push(presentChildEdge);
        });
        let presentChildNodes = presentChildEdges.map(parentEdge => {
          return parentEdge.split('->')[1];
        });
        presentNodeIds = presentChildNodes;
      });
    }

    pathEdges = [...new Set(parentEdges.concat(childEdges))];
  }

  pathEdges.forEach(pathEdge => {
    network.clustering.updateEdge(pathEdge, {
      color: '#1B3FEE',
      width: 10,
      font: {
        size: 50
      }
    });
  });
};
export const unSelectAllEdges = network => {
  const allNodeIds = getAllNetworkNodeIds(network);
  allNodeIds.forEach(nodeId => {
    network.getConnectedEdges(nodeId).forEach(edge => {
      network.clustering.updateEdge(edge, {
        color: '#808080',
        width: 2,
        font: {
          size: 0
        }
      });
    });
  });
};
export const getAllEdgeIds = network => {
  return Object.keys(network.body.data.edges._data);
};
export const getAllNetworkNodeIds = network => {
  return Object.keys(network.body.data.nodes._data);
};